export default __webpack_public_path__ + "static/media/Orc.b35d5e22.webm";